var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2503 19.8911C11.5642 20.1613 12.0377 20.1259 12.308 19.812C12.5782 19.4981 12.5428 19.0246 12.2289 18.7543L11.2503 19.8911ZM1.4989 10.5061L1.005 11.0706L1.00957 11.0745L1.4989 10.5061ZM1.4989 9.75353L1.99278 10.318L1.99342 10.3174L1.4989 9.75353ZM12.2341 1.33633C12.5455 1.06322 12.5766 0.589364 12.3035 0.277945C12.0304 -0.0334742 11.5565 -0.0645267 11.2451 0.208587L12.2341 1.33633ZM12.2289 18.7543L1.98824 9.93773L1.00957 11.0745L11.2503 19.8911L12.2289 18.7543ZM1.99342 10.3174L12.2341 1.33633L11.2451 0.208587L1.00439 9.18966L1.99342 10.3174ZM1.99278 9.94168C2.10661 10.0413 2.10661 10.2184 1.99278 10.318L1.00503 9.1891C0.435868 9.68711 0.435863 10.5725 1.00502 11.0705L1.99278 9.94168Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow_Left.053a89fb349f6faa6ba2643261b58c85.svg";
export { ForwardRef as ReactComponent };